module.exports = __webpack_public_path__ + "static/media/medStaff1.57a69056.jpg";